import React from "react";
import leftPng from "../../../../content/images/left.png";

const Detail = () => {
  return (
    <div id="detailSide" className="d-none">
      <div className="detail-title">Uitvoering in detail</div>
      <div className="clearfix">
        <div className="float-left mt-4">
          <a id="detail-button" className="back-page-link" role="button">
            <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar uitvoering
          </a>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail-active">
            <div className="box-title-1-active">Gisratio Id</div>
            <div className="box-title-2-active" id="d-algemeen-gisratio" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Naam maatregel</div>
            <div className="box-title-2" id="d-maatregel-naam" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Globale palanning</div>
            <div className="box-title-2" id="d-planning-globaleplanning" />
          </div>
        </div>
      </div>

      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Detail planning</div>
            <div className="box-title-2" id="d-planning-detailplanning" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Status</div>
            <div className="box-title-2" id="d-status" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Naam discipline</div>
            <div className="box-title-2" id="d-discipline-naam" />
          </div>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Naam wekplan</div>
            <div className="box-title-2" id="d-werkplan-naam" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Startdatum Planningsperiode</div>
            <div className="box-title-2" id="d-planningsperiode-startdatum" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Tijdstip verzonden</div>
            <div className="box-title-2" id="d-status-tijdstip_verzonden" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Detail;
